import { render, staticRenderFns } from "./BetslipBody.vue?vue&type=template&id=8e21ae62&scoped=true"
import script from "./BetslipBody.vue?vue&type=script&lang=js"
export * from "./BetslipBody.vue?vue&type=script&lang=js"
import style0 from "./BetslipBody.vue?vue&type=style&index=0&id=8e21ae62&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e21ae62",
  null
  
)

export default component.exports